import { Plan, SavingPlanTypes } from 'api/savings-plans';

export const CustomerSubscriptionStatus = {
  /** User has an active subscription */
  Active: 'Active',
  /** User has stopped subscription */
  Churned: 'Churned',
  /** User has never had subscription */
  None: 'None',
} as const;

export function isSavingsPlan(savingsPlan: SavingsPlan | Plan | null): savingsPlan is SavingsPlan {
  if (!savingsPlan) return false;

  return typeof savingsPlan === 'object' && 'planName' in savingsPlan;
}

export type CustomerSubscriptionStatus =
  (typeof CustomerSubscriptionStatus)[keyof typeof CustomerSubscriptionStatus];

export interface SavingsPlan {
  id: string;
  planName: (typeof SavingPlanTypes)[keyof typeof SavingPlanTypes];
  discountPct: number;
  ruleId: string;
  expiresAt: string;
}
export interface Customer {
  createdAt?: number;
  customerId: number;
  email: string;
  hasLoyaltyPoints?: boolean;
  id: number;
  landingPageUrl?: string;
  ordersCount: number;
  subscriptionStatus?: CustomerSubscriptionStatus;
  savingsPlan?: SavingsPlan;
}

export interface PdCustomer {
  email: string;
  id: number;
  isGuest: boolean;
  ordersCount: number;
  segments?: Array<string>;
  subscriptionStatus: string;
}
export interface Address {
  id?: number;
  first_name: string;
  last_name: string;
  address1: string;
  company?: string;
  city: string;
  zip: string;
  country_code: string;
  phone?: string;
  default?: boolean;
}

export interface CheckoutCustomer {
  accepts_marketing: boolean;
  accepts_marketing_updated_at: string;
  addresses: Address[];
  admin_graphql_api_id: string;
  created_at: string;
  currency: string;
  email: string;
  first_name: null | string;
  id: number;
  last_name: null | string;
  last_order_id: null | number;
  last_order_name: string | null;
  marketing_opt_in_level: null;
  multipass_identifier: null;
  note: null | string;
  orders_count: number;
  phone: null | string;
  state: string;
  tags: string;
  tax_exempt: boolean;
  total_spent: string;
  updated_at: string;
  verified_email: boolean;
}

export interface CustomerCredit {
  //
  /** Amount of Digital credit  */
  creditBalance: {
    balance: number;
  } | null;
  /** Transactions of Digital credit  */
  creditTransactions: Array<{
    amount: number;
    createdAt: number;
    reason: string;
    transactionType: 'debit' | 'credit';
  }>;
}
